module.exports = __webpack_public_path__ + "img/img_07.eb44017c.png";